@if (layout() === 'expanded') {
  <div class="flex flex-col items-center gap-4">
    <h3 class="text-lg font-semibold text-slate-700">{{ title() }}</h3>
    <div
      class="grid gap-3"
      [class.grid-cols-1]="uploadFileOnly()"
      [class.grid-cols-2]="!uploadFileOnly()"
    >
      <button
        mat-stroked-button
        class="min-w-[180px]"
        (click)="openFileDialog()"
      >
        <mat-icon class="text-slate-500">cloud_upload</mat-icon>
        <span class="text-sm text-slate-700">Upload File</span>
      </button>
      @if (!uploadFileOnly()) {
        <button
          mat-stroked-button
          class="min-w-[180px]"
          (click)="attachFromPatientFiles()"
        >
          <mat-icon class="text-slate-500">photo_library</mat-icon>
          <span class="text-sm text-slate-700">Patient File</span>
        </button>
      }
    </div>
  </div>
  <input
    #fileInput
    class="hidden"
    type="file"
    multiple
    (change)="startUpload($event)"
  />
  @if (!uploadFileOnly() && !hideClinicalNotes()) {
    <pr-referral-add-clinical-notes
      class="hidden"
      [patient]="patient()"
      [clinicalNotes]="clinicalNotes()"
      (clinicalNotesChanged)="clinicalNotesChanged.emit($event)"
    />
  }
} @else if (uploadFileOnly()) {
  <button mat-icon-button matTooltip="Upload Files" (click)="fileInput.click()">
    <mat-icon>attach_file</mat-icon>
  </button>

  <input
    #fileInput
    class="hidden"
    type="file"
    multiple
    (change)="startUpload($event)"
  />
} @else {
  <button
    mat-icon-button
    matTooltip="Attach Files"
    [matMenuTriggerFor]="attachmentMenu"
  >
    <mat-icon>attach_file</mat-icon>
  </button>

  <input
    #fileInput
    class="hidden"
    type="file"
    multiple
    (change)="startUpload($event)"
  />

  <mat-menu #attachmentMenu="matMenu">
    <button mat-menu-item (click)="fileInput.click()">
      <mat-icon>cloud_upload</mat-icon>
      <span>Upload File</span>
    </button>
    <button mat-menu-item (click)="attachFromPatientFiles()">
      <mat-icon>photo_library</mat-icon>
      <span>Patient File</span>
    </button>
    @if (!hideClinicalNotes()) {
      <pr-referral-add-clinical-notes
        label="Clinical Note"
        [patient]="patient()"
        [clinicalNotes]="clinicalNotes()"
        (clinicalNotesChanged)="clinicalNotesChanged.emit($event)"
      />
    }
  </mat-menu>
}
